import React from "react";
import { LogoMark } from "./Logo";
import { stats } from "../mock";

const circleSketch = (
  <svg
    viewBox="0 0 200 120"
    className="absolute -top-2 -left-3 w-[170px] h-[110px] pointer-events-none"
    aria-hidden="true"
  >
    <path
      d="M 20 60 C 20 20, 180 10, 185 55 C 190 100, 40 110, 25 75"
      fill="none"
      stroke="#2D6A4F"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

const StatCard = ({ stat }) => {
  const { variant, value, label, suffix } = stat;

  if (variant === "light") {
    return (
      <div className="relative bg-[#F3F2EE] rounded-3xl p-8 md:p-10 min-h-[260px] flex flex-col justify-between overflow-hidden">
        <div className="relative inline-block w-fit">
          {circleSketch}
          <div
            className="relative text-[88px] md:text-[110px] font-black leading-none text-[#0E0E10] tracking-tight"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            {value}
          </div>
        </div>
        <p className="text-[#0E0E10] text-[17px] leading-snug max-w-[260px]">
          {label}
        </p>
        <LogoMark
          className="absolute bottom-6 right-6 w-10 h-10"
          color="#6B7C61"
        />
      </div>
    );
  }
  if (variant === "yellow") {
    return (
      <div className="relative bg-[#2D6A4F] rounded-3xl p-8 md:p-10 min-h-[260px] flex flex-col justify-between overflow-hidden">
        <div
          className="text-[88px] md:text-[110px] font-black leading-none text-white tracking-tight"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          {value}
        </div>
        <p className="text-white text-[17px] leading-snug max-w-[260px]">
          {label}
        </p>
        <LogoMark
          className="absolute bottom-6 right-6 w-10 h-10"
          color="#0E0E10"
        />
      </div>
    );
  }
  // navy
  return (
    <div className="relative bg-[#6B7C61] rounded-3xl p-8 md:p-10 min-h-[260px] flex flex-col justify-between overflow-hidden md:col-span-2">
      <div>
        <div
          className="text-[72px] md:text-[110px] font-black leading-none text-white tracking-tight"
          style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
        >
          {value}
        </div>
        {suffix && (
          <div
            className="text-[40px] md:text-[64px] font-light leading-tight text-white/90 tracking-tight mt-1"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            {suffix}
          </div>
        )}
      </div>
      <p className="text-white/70 text-[14px] font-medium mt-6">{label}</p>
      <LogoMark
        className="absolute bottom-6 right-6 w-10 h-10"
        color="#FFFFFF"
      />
    </div>
  );
};

const Stats = () => {
  return (
    <section className="bg-[#F3F2EE] py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-[1300px] mx-auto">
        <div className="grid md:grid-cols-2 gap-10 md:gap-14 mb-12 md:mb-16">
          <h2
            className="text-[40px] md:text-[56px] leading-[1.05] font-bold text-[#0E0E10] tracking-tight"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            We've got the{" "}
            <span className="italic font-normal">numbers</span> to prove it.
          </h2>
          <p className="text-[17px] md:text-[18px] text-[#4A4A4D] leading-relaxed max-w-[480px] md:mt-3">
            From payroll processing to HMRC inspections, our track record
            speaks for itself. Here are the numbers that matter to
            construction businesses across the UK.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {stats.slice(0, 2).map((s, i) => (
            <StatCard key={i} stat={s} />
          ))}
          <StatCard stat={stats[2]} />
        </div>
      </div>
    </section>
  );
};

export default Stats;
